import { Toast } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function ToastMessage({ show, message, bg = 'success', onClose }) {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  const toastContent = (
    <div
      style={{
        position: 'fixed',
        bottom: 'clamp(10px, env(safe-area-inset-bottom) + 10px, 20px)',
        right: '20px',
        zIndex: 2000,
        minWidth: '280px',
        maxWidth: '90vw',
        fontSize: '1.1rem',
      }}
    >
      <Toast
        show={visible}
        autohide
        delay={3000}
        bg={bg}
        onClose={() => {
          setVisible(false);
          onClose?.();
        }}
        style={{
          minWidth: '280px',
          maxWidth: '90vw',
        }}
      >
        <Toast.Body className="text-white">{message}</Toast.Body>
      </Toast>
    </div>
  );

  return createPortal(toastContent, document.body);
}
